import { useTranslation } from 'react-i18next';
import { useMemberData } from 'pages/FirstAccessFlow/context/MemberDataContext';
import React, { useEffect, useState } from 'react';
import { Country, useCountries } from 'pages/FirstAccessFlow/hooks/useCountries';
import { CustomDropdown } from './CustomDropdown';

export function AddressCountryInput() {
  const { t } = useTranslation('redo-register-v2');

  const { handler, formData, setFormEdit } = useMemberData();
  const { countries } = useCountries();
  const [value, setValue] = useState<string>('');
  const [forceError, setForceError] = useState<boolean>(false);

  useEffect(() => {
    const hasCountries = countries.length;

    if (!formData.country && !formData.isForeign && hasCountries) {
      const brazilianCountry = countries.find((country) => country.id === 'Brasil') as Country;
      handler({ country: brazilianCountry.country });
    }

    setValue(formData.country);
  }, [handler, countries]);

  const handleChangeCountry = (country: string) => {
    setFormEdit();
    setForceError(false);
    setValue(country);
    handler({ country });
  };

  return (
    <CustomDropdown
      id="drop__countries"
      idInput="drop__countries--field"
      data-testid="country-input"
      placeholder={t('placeholders.addressCountry')}
      textLabel={t('labels.addressCountry')}
      textMobile={t('labels.addressCountry')}
      actions={countries}
      onClick={handleChangeCountry}
      value={value}
      forceError={forceError}
      errorMessage="Escolha um país"
      isSelectSearch={false}
      disabled={!formData.isForeign}
    />
  );
}
